import { render, staticRenderFns } from "./TrafficOverrunAlert.vue?vue&type=template&id=023440b7"
import script from "./TrafficOverrunAlert.vue?vue&type=script&lang=js"
export * from "./TrafficOverrunAlert.vue?vue&type=script&lang=js"
import style0 from "./TrafficOverrunAlert.vue?vue&type=style&index=0&id=023440b7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports